export default {
  offset: {
    top: 30,
    right: 30,
    bottom: 30,
    left: 30,
  },
  data: {
    volumed: true,
    hover: {
      value: 20
    },
    styles: {
      width: 80,
      color: '#fff',
    },
  },
  texts: {
    center: {
      enable: false,
      text: '100%',
      styles: {
        color: '#ffffff',
        fontSize: 30,
      },
    },
    slicePercent: {
      enable: false,
      styles: {
        color: '#ffffff',
        fontSize: 10,
      },
    },
  },
};
